module.exports = __webpack_public_path__ + "static/media/74664501_2624100607641617_1133167601392812032_o.7f0c6438.png";